import { v4 as uuidv4 } from "uuid";
import { COAST_MESSAGES } from "@inferno/renderer-shared-core";

export enum CoastAlertKind {
  ERROR = "error",
  SUCCESS = "success",
}

export class CoastAlert {
  duration: number;
  id: string;

  constructor(public message: string, public kind: CoastAlertKind, duration?: number) {
    this.id = uuidv4();
    this.duration = duration ?? kind === CoastAlertKind.SUCCESS ? 10000 : 0;
  }
}

export class CoastAlertSuccess extends CoastAlert {
  constructor(message?: string, duration?: number) {
    super(message || COAST_MESSAGES.SUCCESSFUL_UPDATE, CoastAlertKind.SUCCESS, duration);
  }
}

export class CoastAlertError extends CoastAlert {
  constructor(message?: string, duration?: number) {
    super(message || COAST_MESSAGES.UNEXPECTED_ERROR, CoastAlertKind.ERROR, duration);
  }
}
